import $ from "jquery";
import { courseEvaluationReportFilters } from "./courseEvaluationReportFilters";
import { dataaccess } from "../dataaccess/dataContext";

let courseTable;
const tableColumns = ["Program", "SiteDescription", "CourseId", "CourseType", "CourseLength", "Edition", "QuestionText", "QuestionResponse", "QuestionExplanation"];
let dataSet = [];
let currentPage = 1;
let pageSize = 20;
let totalMatchedRecords = 0;
let hasNextPage;
let sort = {};

function init() {
    setEvents();
    buildTable();
}

function setEvents() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(downloadReport);
    $("#next").click(goNextPage);
    $("#previous").click(goPreviousPage);
    $(".sorting, .sorting_asc, .sorting_desc").click(applySort);
}

function downloadReport() {
    let source = $(this).attr("href");

    if (!source.endsWith("?")) {
        source += "?";
        const index = source.indexOf("?");
        source = source.substring(0, index + 1);
    }

    const sourceWithParams = source += $.param(courseEvaluationReportFilters.getQueryStringFilters()).replace(/%5B%5D/g, "");

    $(this).attr("href", sourceWithParams);
}

function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    applyFilters(courseEvaluationReportFilters.getFilters(), false);
}
function goPreviousPage() {
    if (currentPage === 1) return;
    currentPage--;
    applyFilters(courseEvaluationReportFilters.getFilters(), false);
}

function buildDataSet(courses) {
    dataSet = [];
    if (!courses || !courses.length) { return; }
    for (let i = 0; i < courses.length; i++) {
        dataSet.push([
            courses[i].program,
            courses[i].siteDescription,
            courses[i].courseId,
            courses[i].courseType,
            courses[i].courseLength,
            courses[i].edition,
            courses[i].questionText,
            courses[i].questionResponse,
            courses[i].questionExplanation
        ]);
    }
    hasNextPage = (currentPage * pageSize) < totalMatchedRecords;
    setNextPrevButtonEnabled();
}

function buildTable() {
    courseTable = $("#courseTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet,
        "bLengthChange": false,
        "bPaginate": false,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "Program"
                },
                {
                    "targets": 1,
                    "name": "SiteDescription"
                },
                {
                    "targets": 2,
                    "name": "CourseId"
                },
                {
                    "targets": 3,
                    "name": "CourseType"
                },
                {
                    "targets": 4,
                    "name": "CourseLength"
                },
                {
                    "targets": 5,
                    "name": "Edition"
                },
                {
                    "targets": 6,
                    "name": "QuestionText"
                },
                {
                    "targets": 7,
                    "name": "QuestionResponse"
                },
                {
                    "targets": 8,
                    "name": "QuestionExplanation"
                }
            ]
    });
}
function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 1) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}
function applyFilters(isNewSearch) {
    // Resetting current page number to 1 as it is fresh new search criteria(user clicked on the "Run Report" button)
    if (arguments.length === 1 || (arguments[1] && isNewSearch))
        currentPage = 1;

    document.body.style.cursor = 'wait';

    getData().then(function(data) {
        $("#PagingInfo").text("Page " + data.currentPage + " of " + data.pageCount + ". Matched records = " + data.rowCount);
        pageSize = data.pageSize;
        totalMatchedRecords = data.rowCount;
        if (data.results)
            buildDataSet(data.results);
        else
            buildDataSet(data);
        courseTable.clear();
        courseTable.rows.add(dataSet).draw();
        setNextPrevButtonEnabled();
        document.body.style.cursor = 'default';
    });
}
function applySort(e) {
    const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
    $(".sorting, .sorting_asc, .sorting_desc").removeClass()
        .addClass("sorting");

    if (asc) {
        $(this).removeClass("sorting").removeClass("sorting_desc").addClass("sorting_asc");
    } else {
        $(this).removeClass("sorting").removeClass("sorting_asc").addClass("sorting_desc");
    }
    $(".sorting, .sorting_asc, .sorting_desc").not($(this)).removeClass(".sorting_asc").removeClass(".sorting_desc")
        .addClass("sorting");
    sort = {
        column: tableColumns[courseTable.column(this).index()],
        desc: $(this).hasClass("sorting_desc")
    };
    applyFilters(false);
}
function getData() {
    const filters = courseEvaluationReportFilters.getFilters();
    filters.desc = sort.desc;
    filters.sortColumn = sort.column || "";
    return dataaccess.post({ url: "/CourseFacPostEvaluationReport/Responses/" + currentPage, data: filters });
}

export const courseFacPostEvaluationReportResponses = {
    init: init
};